import React, { useState, useEffect } from "react";
import styled from "styled-components";

import * as MUI from "@mui/material";
import { Theme } from "../Theme";
import { ButtonGroup, Button, CircularButton, FilledErrorButton } from "../Button";
import { InputGroup, TextField } from "../Input";
import { FlexRow } from "../Row";

export const Dialog = styled(MUI.Dialog)``;

export const DialogTitle = styled(MUI.DialogTitle)`
  display: flex;
  width: auto;
  flex-direction: row;
  margin: ${(props) => (props.margin ? props.margin : "0")} !important;
  padding: ${(props) =>
    props.padding ? props.padding : "0.5rem 1rem"} !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  align-items: center !important;
`;

export const DialogContent = styled(MUI.DialogContent)`
  width: auto;
  background: ${Theme.white};
  border-radius: 10px !important;
  margin: ${(props) => (props.margin ? props.margin : "0")} !important;
  padding: ${(props) => (props.padding ? props.padding : "0")} !important;
  font-family: inherit !important;
  scrollbar-width: thin;
  scrollbar-color: ${Theme.scrollThumb} ${Theme.scrollBar};
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${Theme.scrollThumb};
    border-radius: 2px;
    cursor: pointer !important;
  }
  &::-webkit-scrollbar-track {
    background: ${Theme.scrollBar};
  }
`;

export const DialogContentText = styled(MUI.DialogContentText)`
  & .MuiTypography-body1 {
    font-size: 12px !important;
  }
`;

export const DialogCloseButton = styled((props) => (
  <CircularButton error outline {...props}>
    <i className="fas fa-times"></i>
  </CircularButton>
))`
  position: absolute !important;
  right: 0.5rem !important;
  align-items: center !important;
  align-self: flex-start !important;
`;

export const DialogActions = styled(MUI.DialogActions)`
  margin: 1rem 0 0.5rem;
  justify-content: center;
  padding-bottom: 1.5rem;
`;

export const DialogBox = ({
  open,
  title,
  content,
  textField,
  textFieldRequired = false,
  label,
  placeholder,
  onTrue,
  onFalse,
  onTrueText = "",
  cancelText = "Cancel",
  errorButton = false
}) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  const onTrueHandler = () => {
    if (textFieldRequired && textField && (value === null || value === ""))
      setError("Field cannot be empty.");
    else onTrue(value);
  };

  useEffect(() => {
    setValue("");
    setError("");
  }, [open]);

  return (
    <Dialog open={open} onClose={() => onFalse()} fullWidth>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent style={{ marginTop: "-16px" }}>
        <FlexRow style={{ padding: "0 1rem" }}>
          {content ? (
            <DialogContentText>
              <span style={{ fontSize: "14px" }}>{content}</span>
            </DialogContentText>
          ) : null}

          {textField ? (
            <InputGroup
              label={label || ""}
              markRequired={textFieldRequired}
              error={error}
            >
              <TextField
                name={"dialog_text_field"}
                disabled={false}
                placeholder={placeholder || "Enter new value"}
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                }}
                error={error}
              />
            </InputGroup>
          ) : null}
        </FlexRow>
      </DialogContent>

      <DialogActions style={{ margin: "1 0.5rem 0" }}>
        <ButtonGroup alignRight>
          <Button primary outline onClick={(e) => onFalse()}>
            {cancelText}
          </Button>
          {errorButton ? 
            <FilledErrorButton  onClick={(e) => onTrueHandler()}>
              {!!onTrueText ? onTrueText : "Done"}
            </FilledErrorButton> : 
            <Button primary onClick={(e) => onTrueHandler()}>
              {!!onTrueText ? onTrueText : "Done"}
            </Button>
          }
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  );
};
